import type { ControlPopulationStatsResponseDto } from "@/spz-api/model";
import { ProgressChart } from "@spz/ui/components/progress-chart";
import { Typography } from "@spz/ui/components/typography";
import { cn } from "@spz/ui/lib/utils";
import type { FC } from "react";

interface PopulationChartProps {
  data: ControlPopulationStatsResponseDto | undefined;
  loading?: boolean;
  className?: string;
}

const PopulationChart: FC<PopulationChartProps> = ({
  data,
  loading = true,
  className,
}) => {
  return (
    <div
      className={cn(
        "bg-white p-4",
        "container rounded justify-between",
        "flex flex-col",
        "h-full",
        className,
      )}
    >
      <Typography variant="h6" trans="population" className="mb-4" />
      <ProgressChart
        value={data?.value ?? null}
        max={data?.max ?? null}
        loading={loading}
      />
    </div>
  );
};

export default PopulationChart;
